const React = require('react')
const { useHistory } = require('react-router-dom')
const { useNetworkConfig } = require('@contexts')

require('@styles/pages/verifyContract/index.css')

const Title = props => {
    const { title } = props
    const history = useHistory()
    const { network } = useNetworkConfig()
    const params = new URLSearchParams(location.search)

    const contractAddress = params.get('a')

    return (
        <div
            style={{
                backgroundColor: title.isSuccess ? 'var(--success-color)' : 'var(--fail-color)',
                borderRadius: '8px',
                padding: '16px',
                margin: '16px 0',
                fontWeight: 'bold'
            }}
        >
            {title.isSuccess ? (
                <spa>
                    Successfully generated matching Bytecode and ABI for Contract Address [
                    <span
                        className={`cursor-pointer`}
                        style={{ color: 'var(--fail-color)', textDecoration: 'none' }}
                        onClick={() => history.push(`/${network.name}/address/${contractAddress}`)}
                    >
                        {contractAddress}
                    </span>
                    ]
                </spa>
            ) : (
                <>Error! {title?.message}</>
            )}
        </div>
    )
}

module.exports = { Title }
